import { Avatar } from "@mantine/core";

const ProfilePicture = ({
    image,
    name,
    alt = "it's my avatar",
    size = "md",
}) => {
    return (
        <Avatar
            src={`https://api.dicebear.com/5.x/${image}/svg?seed=${name}`}
            radius="xl"
            alt={alt}
            // color="green"
            size={size}
        />
    );
};

export default ProfilePicture;
